//
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'

//
// import PurchaseOrderAppends from './PurchaseOrdersAppends'
// import PurchaseOrderIncludes from './purchaseOrdersIncludes'

/**
 *
 */
const fetchInvoicesByNumber = async invoice_number => {
    //
    try {
        //
        const response = await PurchaseOrderModel
            .where( 'invoice_number', invoice_number )
            .get()
        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default fetchInvoicesByNumber
